import { Link } from "gatsby"
import React from "react"

import styles from "./InlineLinkListItem.module.scss"

const InlineLinkListItem = ({
  href,
  text,
  internal,
  element,
  small,
  special,
}) => {
  const Element = element
  return (
    <Element
      className={`${styles.item} ${small ? styles.small : ""} ${
        special ? styles.special : ""
      }`}
    >
      {internal && (
        <Link to={href}>
          <span dangerouslySetInnerHTML={{ __html: text }}></span>
        </Link>
      )}
      {!internal && (
        <a href={href} target="_blank" rel="noopener noreferrer">
          <span dangerouslySetInnerHTML={{ __html: text }}></span>
        </a>
      )}
    </Element>
  )
}

InlineLinkListItem.defaultProps = {
  internal: true,
  element: "li",
}

export default InlineLinkListItem
